import { Spin } from 'antd'
import React from 'react'
import { antIcon } from '../../Helpers/helpers'

const Loader = (props) => {
    return (
        <Spin indicator={antIcon} spinning={props.loading}>
            {props.children}
        </Spin>
    )
}

export default Loader